import { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";

const Recent = () => {
  const startDate = useMemo(() => new Date(2023, 7, 13, 20, 0, 0), []);
  const endDate = useMemo(() => new Date(2024, 11, 20, 0, 0, 0), []);
  const timeDiff = endDate.getTime() - startDate.getTime();

  const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
  const seconds = Math.floor((timeDiff / 1000) % 60);
  return (
    <>
      {timeDiff > 0 ? (
        <p style={{ textAlign: "center", display: "flex", flexDirection: "column", gap: "8px" }}>
          <span style={{ fontSize: "14px" }}>For</span>
          {days} days, {hours} hours, {minutes} minutes, {seconds} seconds
          <span style={{ fontSize: "14px" }}>we were together</span>
        </p>
      ) : (
        <small>Calculating...</small>
      )}
    </>
  );
};

const Current = () => {
  const startDate = useMemo(() => new Date(2024, 11, 28, 22, 0, 0), []);
  const [timeDiff, setTimeDiff] = useState(startDate.getTime() - Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeDiff(Date.now() - startDate.getTime());
    }, 1000);
    return () => clearInterval(interval);
  }, [startDate]);

  const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
  const seconds = Math.floor((timeDiff / 1000) % 60);
  return (
    <>
      {timeDiff > 0 ? (
        <p style={{ textAlign: "center", display: "flex", flexDirection: "column", gap: "8px" }}>
          {days} days, {hours} hours, {minutes} minutes, {seconds} seconds
          <span style={{ fontSize: "14px" }}>since it ended</span>
        </p>
      ) : (
        <small>Calculating...</small>
      )}
    </>
  );
};

const AllTime = () => {
  const startDate = useMemo(() => new Date(2016, 1, 16, 20, 0, 0), []);
  const [timeDiff, setTimeDiff] = useState(startDate.getTime() - Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeDiff(Date.now() - startDate.getTime());
    }, 1000);
    return () => clearInterval(interval);
  }, [startDate]);

  const years = Math.floor(timeDiff / (1000 * 60 * 60 * 24 * 365));
  const months = Math.floor((timeDiff / (1000 * 60 * 60 * 24 * 30)) % 12);
  const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
  const seconds = Math.floor((timeDiff / 1000) % 60);
  return (
    <>
      {timeDiff > 0 ? (
        <div>
          <p
            style={{
              textAlign: "center",
            }}>
            {years} years, {months} months
          </p>
          <p>
            {days} days, {hours} hours, {minutes} minutes, {seconds} seconds
          </p>
          <p style={{ fontSize: "14px", textAlign: "center" }}>since we first met</p>
        </div>
      ) : (
        <small>Calculating...</small>
      )}
    </>
  );
};

type Mode = "allTime" | "recent" | "current";

const modeComponentMap: Record<Mode, JSX.Element> = {
  allTime: <AllTime />,
  recent: <Recent />,
  current: <Current />,
};

const App = () => {
  const [mode, setMode] = useState<Mode>("current");
  const switchMode = () => {
    setMode((prevMode: Mode) => {
      if (prevMode === "current") return "recent";
      if (prevMode === "recent") return "allTime";
      return "current";
    });
  };

  return (
    <div className="container">
      <nav>
        <img
          src="/logo.png"
          height={75}
          width={75}
          alt="loader"
          onClick={switchMode}
          style={{
            cursor: "pointer",
          }}
        />
      </nav>
      <motion.div
        className="overlay"
        initial={{ opacity: 1 }}
        animate={{ opacity: 0, display: "none" }}
        transition={{ duration: 1, delay: 3 }}>
        <motion.img
          src="/logo-light.png"
          height={100}
          width={100}
          alt="loader"
          animate={{
            scale: [1, 1, 1.25, 1, 1, 1.25, 1, 1, 1.25, 1, 1, 1.25, 1],
            transition: { duration: 4 },
          }}
        />
      </motion.div>
      <h1>:)</h1>
      {modeComponentMap[mode]}
    </div>
  );
};

export default App;
